/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useContext } from 'react';
import { Row, Col, H1 } from '@everlywell/leaves';

import { RefsForAnimationContext } from '../../../templates/enterprise';
import BaseHero from '../BaseHero';
import { CTA, FluidImageType } from '../../../utils/types';

import * as S from './styles';

export interface Props {
  headline: string;
  mainCta?: CTA;
  backgroundImage: FluidImageType;
  mobileBackgroundImage?: FluidImageType;
  backgroundColor?: string;
}

export const EnterpriseHero: React.FC<Props> = ({
  headline,
  mainCta,
  ...rest
}) => {
  const { animation1, animation2 } = useContext(RefsForAnimationContext);
  return (
    <BaseHero
      bgTransitionRef={animation1}
      contentTransitionRef={animation2}
      verticalCenter
      {...rest}
    >
      <S.PrimaryContainer>
        <Row>
          <Col xs={12} sm={6} md={5} lg={5} mdOffset={1}>
            <S.Content>
              {headline ? <H1>{headline}</H1> : null}
              {mainCta ? (
                <S.MainCTA href={mainCta.url} appearance="hero">
                  {mainCta.text}
                </S.MainCTA>
              ) : null}
            </S.Content>
          </Col>
        </Row>
      </S.PrimaryContainer>
    </BaseHero>
  );
};

export default EnterpriseHero;
